export enum Orientation {
    NONE = "",
    LANDSCAPE_PRIMARY= 'landscape-primary',
    LANDSCAPE_SECONDARY= 'landscape-secondary',
    PORTRAIT_PRIMARY= 'portrait-primary',
    PORTRAIT_SECONDARY= 'portrait-secondary'
}